import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'
import Img from 'components/common/Img'
import clsx from 'clsx'

export default function HeroSplit({
	pretitle,
	_rawIntro,
	cta,
	image,
	imageOnRight,
	decoration,
}) {
	return (
		<section className="relative overflow-hidden bg-suede-black text-white">
			<Img
				className={clsx(
					'!absolute md:top-0 <md:bottom-0',
					imageOnRight ? 'right-0 -scale-x-100' : 'left-0',
				)}
				image={decoration}
			/>

			<div className="cntr padding grid items-center gap-x-12 gap-y-6 md:grid-cols-2">
				<div className="richtext">
					{pretitle && <p className="technical-lg">{pretitle}</p>}
					<SanityBlock body={_rawIntro} />
					<CTALink {...cta} />
				</div>

				<figure
					className={clsx(
						'mx-auto max-w-[400px]',
						imageOnRight ? 'ml-0' : 'md:order-first md:mr-0',
					)}
				>
					<Img {...image} />
				</figure>
			</div>
		</section>
	)
}
